import {
  GetBuildingSearchReqObj
} from '@gateway.Building'
import { yamadumiApi } from '../yamadumi-api'

/**
 * 物件情報一覧 出力
 */
export class BuildingReportGateway {
  static GetBuildingListReport = async (supplierFormatFlag: number, params: GetBuildingSearchReqObj) => {
    return await yamadumiApi.get<string>('/api/report/building/list',
      { supplierFormatFlag, ...params })
  }
}
